import { useMutation } from '@apollo/client'
import {
  ConfirmInsuranceEligibilityEvent,
  ConfirmInsuranceEligibilityEventVariables,
} from '../../types'
import { CONFIRM_INSURANCE_ELIGIBILITY_EVENT } from './operations'

interface ConfirmInsuranceEligibilityEventProps {
  onCompleted?: () => void
}

export const useConfirmInsuranceEligibilityEvent = ({
  onCompleted,
}: ConfirmInsuranceEligibilityEventProps) =>
  useMutation<ConfirmInsuranceEligibilityEvent, ConfirmInsuranceEligibilityEventVariables>(
    CONFIRM_INSURANCE_ELIGIBILITY_EVENT,
    {
      onCompleted,
    }
  )
